import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';
import type { NodeCfg } from '../nodes';
import { locationSchema } from '../../location.deployParam';
import { ProcessDataElementKindEnum } from '../../../../../db';

export const processSolveNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('processSolve'),
    controlValues: z.object({
        location: locationSchema,
        processId: z.string().uuid(),
        useStandardizedOutputs: z.object({
            // status: z.boolean().default(true),
            // specId: z.boolean().default(true),
            // badCount: z.boolean().default(true),
            // specName: z.boolean().default(true),
            // goodCount: z.boolean().default(true),
            // requiredCount: z.boolean().default(true),
            solveFailReason: z.boolean().default(true),
        }),
        processParameters: z.array(z.object({
            id: z.string(),
            name: z.string(),
            // sourceVarId: z.string(),
            // NOTE: Process params cannot have the `material` type like process data elements can
            type: z.enum([ ProcessDataElementKindEnum.String, ProcessDataElementKindEnum.Number, ProcessDataElementKindEnum.Boolean ]),
        })),
    }),
});
export interface ProcessSolveNodeCfgSchema extends z.infer<typeof processSolveNodeCfgSchema> {}

export const processSolveNodeSocketCfg = {
    controlSockets: {
        inputs: () => ({
            solve: 'event',
        }),
        outputs: () => ({
            solveFail: 'event',
            solveSuccess: 'event',
        }),
    },
    dataSockets: {
        inputs: (_cfg: NodeCfg<'processSolve'>): Record<'materialId', 'string'> => {
            const ret: Record<'materialId', 'string'> = {
                materialId: 'string',
            };
            return ret;
        },
        outputs: (cfg: NodeCfg<'processSolve'>): Record<`param_${string}`, 'string' | 'number' | 'boolean'> => {
            const ret: Record<`param_${string}`, 'string' | 'number' | 'boolean'> = {};
            // if (cfg.controlValues.useStandardizedOutputs.status) {
            //     ret.de_status = 'string';
            // }
            // if (cfg.controlValues.useStandardizedOutputs.specId) {
            //     ret[`de_${specId}`] = 'string';
            // }
            // if (cfg.controlValues.useStandardizedOutputs.specName) {
            //     ret.de_specName = 'string';
            // }
            // if (cfg.controlValues.useStandardizedOutputs.requiredCount) {
            //     ret.de_requiredCount = 'number';
            // }
            if (cfg.controlValues.useStandardizedOutputs.solveFailReason) {
                ret.param_solveFailReason = 'string';
            }
            for (const de of cfg.controlValues.processParameters) {
                if (de.type === ProcessDataElementKindEnum.String) {
                    ret[`param_${de.id}`] = 'string';
                } else if (de.type === ProcessDataElementKindEnum.Number) {
                    ret[`param_${de.id}`] = 'number';
                } else if (de.type === ProcessDataElementKindEnum.Boolean) {
                    ret[`param_${de.id}`] = 'boolean';
                }
            }
            return ret;
        },
    },
} satisfies NodeSocketCfg<ProcessSolveNodeCfgSchema>;
